import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import merge from "deepmerge";
import { useRouter } from "next/router";
import { useEffect, useMemo, useReducer } from "react";
var defaultInitialState = {
  nextStep: 1,
  formData: {},
  clearError: true
};

var reducer = function reducer(state, action) {
  var newState = _objectSpread({}, state);

  var _action$formData = action.formData,
      formData = _action$formData === void 0 ? {} : _action$formData,
      _action$clearError = action.clearError,
      clearError = _action$clearError === void 0 ? true : _action$clearError;

  switch (action.type) {
    case "set":
      return merge(newState, {
        formData: formData,
        clearError: clearError
      });

    case "next":
      return merge(newState, {
        nextStep: state.nextStep + 1,
        formData: formData,
        clearError: clearError
      });

    case "prev":
      return merge(newState, {
        nextStep: state.nextStep - 1,
        formData: formData,
        clearError: clearError
      });

    case "step":
      return merge(newState, {
        nextStep: action.step
      });

    default:
      return state;
  }
};

var defaultOptions = {
  maxStep: 3,
  completeStep: null
};
export function useStep() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = _objectSpread(_objectSpread({}, defaultOptions), options);

  var _useReducer = useReducer(reducer, _objectSpread(_objectSpread({}, defaultInitialState), initialState)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var router = useRouter();
  var step = useMemo(function () {
    var _router$query, _router$query$step;

    var step = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : (_router$query$step = _router$query.step) === null || _router$query$step === void 0 ? void 0 : _router$query$step.toString();
    if (!step) return 1;
    var matches = step.match(/^step(\d)$/);
    var stepNum = Number(matches[1]);

    if (stepNum <= options.maxStep) {
      return stepNum;
    } else {
      return 1;
    }
  }, [router.query, options.maxStep]);
  useEffect(function () {
    // ブラウザバック
    router.beforePopState(function (_ref) {
      var as = _ref.as;
      var match = as.match( /*#__PURE__*/_wrapRegExp(/step(\d)/, {
        step: 1
      }));

      var nextStep = function () {
        var num = Number(match === null || match === void 0 ? void 0 : match.groups.step);
        if (isNaN(num)) return 1;
        return num;
      }();

      if (match) {
        // completeStepまでいったらブラウザバックさせない
        if (options.completeStep && state.nextStep === options.completeStep) {
          window.history.go(1);
          return false;
        }

        if (state.nextStep > nextStep) {
          dispatch({
            type: "prev"
          });
        } else if (state.nextStep < nextStep) {
          dispatch({
            type: "next"
          });
        } else if (state.nextStep === nextStep) {
          return true;
        }

        return false;
      } else {
        return true;
      }
    });
    return function () {
      router.beforePopState(function () {
        return true;
      });
    };
  }, [state.nextStep, options.completeStep]);
  return {
    step: step,
    state: state,
    dispatch: dispatch
  };
}